import { z } from "zod";
export const MeetingRecordingStatusSchema = z.enum(["uploaded", "processing", "ready", "failed"]);
export const MeetingTranscriptStatusSchema = z.enum([
    "not_requested",
    "queued",
    "processing",
    "ready",
    "failed",
]);
export const MeetingRecordingSchema = z.object({
    id: z.string().uuid(),
    title: z.string().min(1).max(240),
    platform: z.string().min(1).max(40),
    status: MeetingRecordingStatusSchema,
    source: z.string().min(1).max(40),
    filename: z.string().min(1).max(500),
    blobKey: z.string().min(1),
    mimeType: z.string().max(100),
    sizeBytes: z.number().int().nonnegative(),
    durationSeconds: z.number().int().nonnegative(),
    recordedAt: z.string().datetime(),
    projectId: z.string().uuid().nullable(),
    contactId: z.string().uuid().nullable(),
    companyId: z.string().uuid().nullable(),
    boardMeetingId: z.string().uuid().nullable(),
    transcriptStatus: MeetingTranscriptStatusSchema,
    summaryStatus: MeetingTranscriptStatusSchema,
    metadata: z.record(z.string(), z.unknown()),
    uploadedBy: z.string().email(),
    archivedAt: z.string().datetime().nullable().default(null),
    archivedBy: z.string().email().nullable().default(null),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const MeetingRecordingCreateSchema = z.object({
    title: z.string().trim().min(1).max(240),
    platform: z.string().trim().min(1).max(40).default("unknown"),
    source: z.string().trim().min(1).max(40).default("manual"),
    filename: z.string().min(1).max(500),
    blobKey: z.string().min(1).max(1000),
    mimeType: z.string().max(100),
    sizeBytes: z.number().int().nonnegative().default(0),
    durationSeconds: z.number().int().nonnegative().default(0),
    recordedAt: z.string().datetime().optional(),
    projectId: z.string().uuid().nullable().optional(),
    contactId: z.string().uuid().nullable().optional(),
    companyId: z.string().uuid().nullable().optional(),
    boardMeetingId: z.string().uuid().nullable().optional(),
    metadata: z.record(z.string(), z.unknown()).default({}),
});
export const MeetingRecordingListQuerySchema = z.object({
    status: MeetingRecordingStatusSchema.optional(),
    search: z.string().max(200).optional(),
    includeArchived: z.coerce.boolean().optional(),
    archivedOnly: z.coerce.boolean().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export const MeetingRecordingListResponseSchema = z.object({
    recordings: z.array(MeetingRecordingSchema),
    total: z.number().int(),
});
export const MeetingUploadTokenRequestSchema = z.object({
    filename: z.string().min(1).max(500),
    contentType: z.string().min(1).max(100),
});
export const MeetingUploadTokenResponseSchema = z.object({
    uploadUrl: z.string().url(),
    blobKey: z.string().min(1),
    expiresAt: z.string().datetime(),
});
//# sourceMappingURL=meetings.js.map